import React, { useContext, useEffect, useState } from "react";
import "./UnderContractPanel.css";
import moveTeamImg from "../../../../assets/moveTeamImg";
import moveTeamImgWhite from "../../../../assets/moveTeamImgWhite";
import ThirdPartyItem from "./ThirdPartyItem/ThirdPartyItem";
import calendarSvg from "../../../../assets/calendarSvg";
import houseSvg from "../../../../assets/houseSvg";
import { AppContext } from "../../../../AppContext";
import AgentQuestionModal from "./AgentRequestModal/AgentQuestionModal";
import { UnderContractPanelContext } from "./UnderContractPanelContext";
import ChangeDateModal from "./AgentRequestModal/ChangeDateModal";
import questionMarkSvg from "../../../../assets/questionMarkSvg";
import calendarSvgTwo from "../../../../assets/calendarSvgTwo";

const UnderContractPanel = ({
  index,
  clientName = "Client Name",
  closingDate,
  status = "Status",
  address = "Address",
  cityState = "City, ST",
  titleStatus = null,
  hoiStatus = null,
  appraisalStatus = null,
  appraisalInspectionDate,
  condoDocsStatus = null,
  propertyType = "Property Type",
  loanOfficer = "Loan Officer",
  loanOfficerEmail,
  loanEngineer = "Loan Engineer",
  loanEngineerEmail,
  loanProcessor = "Processor",
  loanProcessorEmail,
  loanAvailabilityDeadlineDate,
  appraisalDeadlineDate,
  condoDocsDeadlineDate,
  hoiDeadlineDate,
  inspectionResolutionDeadlineDate,
  titleDeadlineDate,
  buyersAgent,
  appraisalValue,
  appraisalCondition,
  id,
  agentEmails,
  coAgentName,
}) => {
  const checkForTeamContacts = loanOfficerEmail
    ? loanEngineerEmail
      ? loanProcessorEmail
        ? true
        : false
      : false
    : false;

  const { ucPanelsController, setUcPanelsController, userName, userType } =
    useContext(AppContext);

  const formatDate = (field) => {
    if (field) {
      const convertToDate = new Date(field.toString());
      return (
        convertToDate.getMonth() +
        1 +
        "/" +
        convertToDate.getDate() +
        "/" +
        convertToDate.getFullYear().toString().substring(2, 4)
      );
    } else {
      return "TBD";
    }
  };

  function formatCurrency(number) {
    const formattedNumber = number.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return `$${formattedNumber}`;
  }

  const closingDateFormatted = formatDate(closingDate);
  const appraisalInspectionDateFormatted = formatDate(appraisalInspectionDate);
  const appraisalDeadlineDateFormatted = formatDate(appraisalDeadlineDate);
  const condoDocsDeadlineDateFormatted = formatDate(condoDocsDeadlineDate);
  const hoiDeadlineDateFormatted = formatDate(hoiDeadlineDate);
  const inspectionResolutionDeadlineDateFormatted = formatDate(
    inspectionResolutionDeadlineDate
  );
  const loanAvailabilityDeadlineDateFormatted = formatDate(
    loanAvailabilityDeadlineDate
  );
  const titleDeadlineDateFormatted = formatDate(titleDeadlineDate);

  const [ucAdd, setUcAdd] = useState("hidden");
  const [agentQuestionModal, setAgentQuestionModal] = useState(false);
  const [changeDateModal, setChangeDateModal] = useState(false);

  useEffect(() => {
    setUcAdd(
      ucPanelsController[index] == true ||
        ucPanelsController[index] == undefined
        ? "hidden"
        : ""
    );
  }, [ucPanelsController]);

  let ucPanel = "underContractPanel";
  let thirdPartyItems = "underContract-thirdPartyItems";
  let moveTeamImgSelected = moveTeamImg;
  if (
    status === "Clear to Close" ||
    status === "Docs Out" ||
    status === "Closed" ||
    status === "Funded"
  ) {
    ucPanel = "underContractPanel blueGradient";
    thirdPartyItems = false;
    moveTeamImgSelected = moveTeamImgWhite;
  }

  const ucDates = [
    [
      appraisalStatus !== "Waiver"
        ? appraisalInspectionDateFormatted
        : appraisalStatus,
      "Appraisal Inspection",
      true,
      appraisalStatus !== "Waiver" && appraisalInspectionDate !== "TBD"
        ? new Date(appraisalInspectionDate) < new Date()
        : false,
      appraisalInspectionDate,
    ],
    [
      loanAvailabilityDeadlineDateFormatted,
      "Loan Availability Deadline",
      true,
      loanAvailabilityDeadlineDate !== "TBD"
        ? new Date(loanAvailabilityDeadlineDate) < new Date()
        : false,
      loanAvailabilityDeadlineDate,
    ],
    [
      closingDateFormatted,
      "Estimated Closing Date",
      true,
      closingDate !== "TBD" ? new Date(closingDate) < new Date() : false,
      closingDate,
    ],
    [
      appraisalDeadlineDateFormatted,
      "Appraisal Deadline",
      true,
      appraisalDeadlineDate !== "TBD"
        ? new Date(appraisalDeadlineDate) < new Date()
        : false,
      appraisalDeadlineDate,
    ],
    [
      condoDocsDeadlineDateFormatted,
      "Condo Doc Deadline",
      propertyType === "Condominium",
      condoDocsDeadlineDate !== "TBD"
        ? new Date(condoDocsDeadlineDate) < new Date()
        : false,
      condoDocsDeadlineDate,
    ],
    [
      hoiDeadlineDateFormatted,
      "HOI Deadline",
      true,
      hoiDeadlineDate !== "TBD"
        ? new Date(hoiDeadlineDate) < new Date()
        : false,
      hoiDeadlineDate,
    ],
    [
      inspectionResolutionDeadlineDateFormatted,
      "Inspection Resolution Deadline",
      true,
      inspectionResolutionDeadlineDate !== "TBD"
        ? new Date(inspectionResolutionDeadlineDate) < new Date()
        : false,
      inspectionResolutionDeadlineDate,
    ],
    [
      titleDeadlineDateFormatted,
      "Title Deadline",
      true,
      titleDeadlineDate !== "TBD"
        ? new Date(titleDeadlineDate) < new Date()
        : false,
      titleDeadlineDate,
    ],
  ];

  const browser = navigator.userAgent.toString();

  const ucDatesSorted = ucDates.sort((a, b) => new Date(a[4]) - new Date(b[4]));

  const ucDatesList = [];

  ucDatesSorted.forEach((e, index) => {
    if (e[2] && e[0] !== "TBD") {
      ucDatesList.push(
        <li key={index} className={e[3] ? `datePassed` : null}>
          <b>{e[0]}</b> | {e[1]}{" "}
        </li>
      );
    } else {
    }
  });
  const isAgent = () => {
    if (
      userType == "Agent" &&
      userName !== buyersAgent &&
      userName !== coAgentName
    ) {
      return false;
    } else {
      return true;
    }
  };

  const ucInfo = (
    <div className={`ucInfo ${ucAdd}`}>
      <br></br>
      <div className="ucInfo-one">
        <div className="ucInfo-agent">
          <b>{coAgentName ? `${buyersAgent} & ${coAgentName}` : buyersAgent}</b>{" "}
          |{coAgentName ? "Agents" : "Agent"}
        </div>
        <span className="address">
          {address}, {cityState}
        </span>
      </div>
      {isAgent() ? (
        <div className="ucInfo-dates">
          {houseSvg}
          <div className="ucDates">
            {appraisalStatus === "Waiver" ? (
              <li>
                <b>Appraisal Waived!</b> An appraisal will not be ordered.
              </li>
            ) : (
              <>
                <li>
                  <b>
                    {appraisalValue ? formatCurrency(appraisalValue) : "TBD"}
                  </b>{" "}
                  | Appraised Value
                </li>
                <li>
                  <b>{appraisalCondition ? appraisalCondition : "TBD"}</b> |
                  Appraised Condition
                </li>
              </>
            )}
          </div>
        </div>
      ) : null}
      <hr className="ucInfo-bar"></hr>
      <div className="ucInfo-dates">
        {calendarSvg}
        <div className="ucDates">{ucDatesList}</div>
      </div>
      <hr className="ucInfo-bar"></hr>
      {checkForTeamContacts ? (
        <>
          <div className="ucInfo-moveTeam">
            {moveTeamImgSelected}
            <div className="marginAuto marginLeftZero">
              <li>
                <b>{loanOfficer}</b> | Loan Officer
              </li>
              <li>
                <b>{loanProcessor}</b> | Processor
              </li>
              <li>
                <b>{loanEngineer}</b> | Loan Engineer
              </li>
            </div>
          </div>
          <div className="blankRow tenPx"></div>
          <div className="blankRow tenPx"></div>
          <div
            className="button long"
            onClick={(e) => {
              e.stopPropagation();
              setAgentQuestionModal(true);
            }}
          >
            <div
              className={`buttonIcon ${
                !thirdPartyItems ? "fillGrey" : "fillWhite"
              }`}
            >
              {questionMarkSvg}
            </div>
            <div className="button-text">Send Question</div>
          </div>
          <div className="blankRow tenPx"></div>
          <div
            className="button long"
            onClick={(e) => {
              e.stopPropagation();
              setChangeDateModal(true);
            }}
          >
            <div
              className={`buttonIcon ${
                !thirdPartyItems ? "fillGrey" : "fillWhite"
              }`}
            >
              {calendarSvgTwo}
            </div>
            <div className="button-text">Change Date</div>
          </div>
        </>
      ) : (
        <>
          <div className="ucInfo-moveTeam">
            {moveTeamImgSelected}
            <div className="marginAuto">
              <li>
                <b>{loanOfficer}</b> | Loan Officer
              </li>
            </div>
          </div>
          <div className="blankRow tenPx"></div>
          <div className="blankRow tenPx"></div>
          <div className="chatMessage">
            <div className="chatMessageNotes">
              The Processing Team is reviewing and registering the loan now. You
              can expect to see updates here shortly.
            </div>
          </div>
        </>
      )}
    </div>
  );

  return (
    <UnderContractPanelContext.Provider
      value={{
        agentQuestionModal,
        setAgentQuestionModal,
        changeDateModal,
        setChangeDateModal,
        clientName,
        id,
        loanOfficerEmail,
        loanEngineerEmail,
        loanProcessorEmail,
        agentEmails,
      }}
    >
      <div
        className={ucPanel}
        onClick={(e) => {
          if (e.target.id !== "prioritizeClick") {
            let arrayOfPanels = [];
            for (
              let i = 0;
              i < document.getElementsByClassName("ucInfo").length;
              i++
            ) {
              if (
                ucPanelsController[index] != undefined
                  ? ucPanelsController[index] && i == index
                  : i == index
              ) {
                arrayOfPanels.push(false);
              } else {
                arrayOfPanels.push(true);
              }
            }
            setUcPanelsController(arrayOfPanels);
          } else {
          }
        }}
      >
        <div className="underContractPanel-container">
          <div className="uc-titleBar">
            <div className="ucTitle">
              <span className="left">
                {isAgent() ? (
                  <span className="clientName">{clientName}</span>
                ) : (
                  <span className="clientName">{address}</span>
                )}
                <div className="ucSubtitle">{status}</div>
              </span>
              <span className="right">
                <span className="closingDate">{closingDateFormatted}</span>
                <span className="closing">EST. CLOSING</span>
              </span>
            </div>
          </div>
          {!thirdPartyItems ? (
            <div className="centered">✨ Cleared to Close 🥳 ✨</div>
          ) : (
            <div className="underContract-thirdPartyItems">
              <ThirdPartyItem item="Title" status={titleStatus} />
              <ThirdPartyItem item="Homeowners Insurance" status={hoiStatus} />
              <ThirdPartyItem item="Appraisal" status={appraisalStatus} />
              {condoDocsStatus === "N/A" ? null : (
                <ThirdPartyItem item="Condo Docs" status={condoDocsStatus} />
              )}
            </div>
          )}
          {ucInfo}
        </div>
        <AgentQuestionModal />
        <ChangeDateModal />
      </div>
    </UnderContractPanelContext.Provider>
  );
};

export default UnderContractPanel;
